<script lang="ts" setup>
  const { isDesktop } = useDeviceType();
</script>

<template>
  <section class="@container/deposit-options w-full flex flex-col items-center">
    <h2
      class="text-white text-center font-barlow text-[52px] md:text-[80px] font-extrabold leading-[110%] uppercase mb-4 md:mb-5"
    >
      Deposit Options
    </h2>
    <p
      class="text-white text-center font-barlow text-base md:text-xl font-medium leading-6 mb-4 md:mb-2 max-w-[44.6875rem]"
    >
      Fast and secure deposits in all major cryptocurrencies. Pay with Bitcoin, Ethereum, Solana, USDT & more.
    </p>
    <div class="-mx-5 mb-8 md:mx-auto">
      <CoreImage
        alt="Deposit in all major cryptocurrencies"
        class="block md:hidden"
        format="webp"
        sizes="xs:100vw"
        loading="lazy"
        src="/images/lo-hp-new/art-coins-mobile.webp"
      />
      <CoreImage
        alt="Deposit in all major cryptocurrencies"
        class="hidden md:block max-w-[45.8125rem]"
        format="webp"
        sizes="md:580px lg:1000px xl:1086px"
        loading="lazy"
        src="/images/lo-hp/art-coins-desktop.webp"
      />
    </div>
    <div
      class="w-full rounded-[10px] overflow-hidden xl:overflow-visible border border-transparent bg-gradient-to-br from-[#0874BF] via-[#0257A5] to-[#053A8D] bg-white/5 backdrop-blur-[25px] lg:flex lg:justify-center lg:items-center lg:gap-[1.75rem] lg:my-20"
    >
      <div class="px-10 pt-10 lg:p-0 lg:pl-[60px] xl:items-end lg:flex lg:items-center lg:gap-4">
        <div class="lg:text-left shrink-0">
          <p class="text-white font-barlow text-base lg:text-xl font-medium leading-[1.5] mb-1.5">
            No Crypto? No Problem.
          </p>
          <p
            class="text-white font-barlow text-[40px] lg:text-[56px] font-extrabold leading-[1.2] uppercase mb-3 lg:mb-0"
          >
            Deposit via
          </p>
        </div>
        <CoreImage
          alt="Deposit via PayPal"
          class="mx-auto"
          format="webp"
          sizes="xs:127px md:180px"
          loading="lazy"
          src="/images/lo-hp/paypal-white.png"
        />
      </div>
      <div
        v-if="isDesktop"
        class="relative w-full max-h-none md:max-h-[250px] overflow-hidden lg:aspect-auto lg:w-auto lg:overflow-visible lg:pr-7"
      >
        <CoreImage
          alt="cards"
          class="mx-auto aspect-[277/317] lg:aspect-auto lg:translate-y-1/4 mt-[-50%] lg:max-h-[374px]"
          format="webp"
          sizes="xs:277px md:325px"
          loading="lazy"
          src="/images/lo-hp/cards-art.png"
        />
      </div>
      <CoreImage
        v-else
        alt="cards"
        class="mx-auto w-[80%] xs:w-[50%] object-contain relative bottom-[-80px] aspect-[151/173]"
        format="webp"
        sizes="xs:277px md:325px"
        loading="lazy"
        src="/images/lo-hp/cards-art.png"
      />
    </div>
  </section>
</template>
